var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        {
          directives: [{ name: "drag", rawName: "v-drag" }],
          staticClass: "wrap",
          attrs: { draggable: "false" },
        },
        [
          _c(
            "div",
            { staticClass: "icon-wrap" },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "取消呼叫",
                    placement: "top-start",
                  },
                },
                [
                  _c("img", {
                    staticClass: "calling-icon",
                    attrs: {
                      src: require("@/assets/call/calling2.png"),
                      alt: "",
                    },
                    on: { click: _vm.callOutCancel },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm.webSocketMsg.status == 0 || _vm.webSocketMsg.status == 3
            ? _c("span", { staticStyle: { "font-size": "24px" } }, [
                _vm._v("拨号中..."),
              ])
            : _c(
                "span",
                {
                  class:
                    _vm.webSocketMsg.status === 2 ||
                    _vm.webSocketMsg.status === 99
                      ? "off"
                      : "",
                },
                [_vm._v(_vm._s(_vm.duration))]
              ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }